import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = ({ children, requiredRole }) => {
  const location = useLocation();
  const { user, loading, isAuthenticated } = useAuth();
  
  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  
  // If not authenticated, redirect to login with return URL
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Check if user has required role (if specified)
  if (requiredRole && (!user || !user.roles || !user.roles.includes(requiredRole))) {
    // User doesn't have required role, redirect to home or unauthorized page
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }
  
  // User is authenticated and has required role (if specified)
  return children;
};

export default ProtectedRoute;
